import React from 'react';
import PropTypes from 'prop-types';
// Note: There is a cycle because the Step can render anything inside of it.
// eslint-disable-next-line import/no-cycle
import ContentfulRichText from './index';
import StepWrapper from './Step.style';

const Step = (props) => {
  const {
    number,
    content,
  } = props;

  return (
    <StepWrapper>
      <div className="left-column">
        <span className="number-content">{number}</span>
      </div>
      <div className="right-column">
        <ContentfulRichText richText={content} />
      </div>
    </StepWrapper>
  );
};

Step.propTypes = {
  number: PropTypes.number.isRequired,
  content: PropTypes.shape({
    raw: PropTypes.string.isRequired,
  }).isRequired,
};

export default Step;
